var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Path, Svg, Text } from "react-native-svg";
var Guide = function (props) {
    var _a = props.viewBox, width = _a.width, height = _a.height, x = _a.x, y = _a.y;
    return React.createElement(React.Fragment, null, new Array(props.frecuencyTable.parts + 1).fill(0).map(function (a, i) {
        var _a;
        // const xcenter = (i * (width / props.frecuencyTable.parts)) + x
        var ycenter = (y + height) - (i * (height / props.frecuencyTable.parts));
        return React.createElement(React.Fragment, null,
            React.createElement(Path, { key: "r" + i, strokeWidth: 1, stroke: "#666", fill: "transparent", d: [
                    "M", x, ycenter,
                    "H", x + width,
                ].join(" ") }),
            React.createElement(Path, { key: "r" + i, strokeWidth: 1, stroke: "#666", fill: "transparent", d: [
                    "M", x, height + y,
                    "L", width + x, height + y,
                ].join(" ") }),
            React.createElement(Text, { dx: x - 4, dy: ycenter, textAnchor: "end", fill: (_a = props.textColor) !== null && _a !== void 0 ? _a : "#000", fontSize: 10, translateY: 4 }, props.frecuencyTable.range_min + (props.frecuencyTable.scale * i)));
    }));
};
var recursive_niveles = function (props, index, key) {
    var _a;
    if (index === void 0) { index = 0; }
    if (key === void 0) { key = ""; }
    if (!props.frecuencyTable.niveles[index])
        return null;
    var _b = props.viewBox, width = _b.width, height = _b.height, x = _b.x, y = _b.y;
    var heightInterval = (height / props.frecuencyTable.niveles[index].length);
    var widthInterval = (width / props.frecuencyTable.niveles[index].length);
    // let padding = widthInterval * 0.1;
    var padding = heightInterval * ((_a = props.space) !== null && _a !== void 0 ? _a : 0);
    var paddingV = heightInterval * 0.1;
    // console.log(props.frecuencyTable)
    return props.frecuencyTable.niveles[index].map(function (a, i) {
        var _a, _b;
        var indexAux = props.frecuencyTable.intervals.findIndex(function (itm) { return itm == (!key ? a : key + "-" + a); });
        // console.log(props.frecuencyTable);
        var fy = 0;
        if (indexAux > -1) {
            fy = props.frecuencyTable.relative_frequency_scaled[indexAux];
            padding = 0;
            paddingV = 0;
        }
        if (props.frecuencyTable.niveles[index].length >= index) {
            padding = padding;
            paddingV = paddingV;
        }
        var ys = ((i * heightInterval) + y) + (padding / 2);
        var xs = ((i * widthInterval) + x) + (padding / 2);
        var ye = ((i * heightInterval) + heightInterval + y) - (padding / 2);
        var xe = ((i * widthInterval) + widthInterval + x) - (padding / 2);
        var ycenter = ys + (heightInterval / 2);
        var strokeWidth = props.strokeWidth;
        return React.createElement(React.Fragment, null,
            !props.showLabel ? null :
                React.createElement(Text, { dx: (xs + strokeWidth + (widthInterval / 2)) - padding / 2, dy: height + y + 12 + paddingV, 
                    // translateY={4}
                    textAnchor: "middle", fill: (_a = props.textColor) !== null && _a !== void 0 ? _a : "#000", fontSize: 10 }, a),
            indexAux <= -1 ? null : React.createElement(React.Fragment, null,
                React.createElement(Path, { key: "r" + i, strokeWidth: strokeWidth, stroke: props.frecuencyTable.intervals_color[indexAux], fill: props.frecuencyTable.intervals_color[indexAux] + "22", 
                    // fill={"transparent"}
                    d: [
                        "M", xs + strokeWidth + padding, height + y,
                        "V", (height + y) - ((height) * fy),
                        "H", xe - strokeWidth,
                        "V", y + height,
                        // "Z"
                    ].join(" ") }),
                !props.showValue ? null : React.createElement(Text, { dx: xs + (widthInterval / 2), dy: (height + y) - ((height) * fy) - 4, textAnchor: "middle", fill: (_b = props.textColor) !== null && _b !== void 0 ? _b : "#000", fontSize: 10 }, props.frecuencyTable.frequency_data[indexAux])),
            recursive_niveles(__assign(__assign({}, props), { viewBox: __assign(__assign({}, props.viewBox), { width: widthInterval - padding, x: xs }) }), index + 1, !key ? a : key + "-" + a));
    });
};
var Niveles = function (props) {
    return React.createElement(React.Fragment, null, recursive_niveles(props, 0, ""));
};
export default (function (props) {
    var _a = props.viewBox, width = _a.width, height = _a.height, x = _a.x, y = _a.y;
    var newViewBox = { width: width, height: height, x: x, y: y };
    if (!props.showGuide && props.showLabel) {
        newViewBox = { width: width, height: height - 38, x: 0, y: 4 };
    }
    if (props.showGuide && !props.showLabel) {
        newViewBox = { width: width - 38, height: height - 8, x: 30, y: 4 };
    }
    if (props.showGuide && props.showLabel) {
        newViewBox = { width: width - 38, height: height - 38, x: 30, y: 4 };
    }
    return React.createElement(Svg, { height: "100%", width: "100%", viewBox: "0 0 ".concat(width, " ").concat(height) },
        !props.showGuide ? null : React.createElement(Guide, __assign({}, props, { viewBox: newViewBox })),
        React.createElement(Niveles, __assign({}, props, { viewBox: newViewBox })));
});
